import React, { useState } from 'react';

import StartPage from '../StartPage';
import Game from '../Game';

const GemContainer = () => {
  const [runing, setRuning] = useState(false);
  return runing ? <Game /> : <StartPage startClick={() => setRuning(true)} />;
};

export default GemContainer;
